"use strict";

var _require = require("./internal-constants"),
    domSymbolTree = _require.domSymbolTree;

var _require2 = require("../node-type"),
    TEXT_NODE = _require2.TEXT_NODE;

exports.childTextContent = function (node) {
  var result = "";
  var iterator = domSymbolTree.childrenIterator(node);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = iterator[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var child = _step.value;

      if (child.nodeType === TEXT_NODE) {
        result += child.data;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
};